(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    /* =========================================================
   Section 40 - Clock-synchronized hourly sale countdown
   Resets at each visitor-local hour and survives refreshes.
   ========================================================= */
(function () {
  function initializeGinniSaleTimers() {
    document.querySelectorAll('.ginni-product-details-column').forEach(function (details) {
      if (details.querySelector('.ginni-sale-timer-bar')) return;

      var title = details.querySelector('[data-testid="product-title"], .product-title, h1');
      if (!title) return;

      var titleGroup = title.closest('.group-block') || title;
      if (!titleGroup.parentNode) return;

      var bar = document.createElement('div');
      bar.className = 'ginni-sale-timer-bar';
      bar.setAttribute('role', 'timer');
      bar.setAttribute('aria-label', 'Sale ends countdown');

      var discount = document.createElement('span');
      discount.className = 'ginni-sale-timer-discount';

      function getActualDiscount() {
        var data = details.querySelector('.ginni-discount-data');
        if (!data) return 0;
        var price = parseInt(data.dataset.price || '0', 10);
        var compareAt = parseInt(data.dataset.compareAt || '0', 10);
        if (!price || !compareAt || compareAt <= price) return 0;
        return Math.round(((compareAt - price) / compareAt) * 100);
      }

      function updateDiscountLabel() {
        var actualDiscount = getActualDiscount();
        discount.textContent = actualDiscount > 0 ? actualDiscount + '% OFF' : 'SALE';
      }
      updateDiscountLabel();

      var label = document.createElement('span');
      label.className = 'ginni-sale-timer-label';
      label.textContent = 'Sale might end in';

      var countdown = document.createElement('span');
      countdown.className = 'ginni-sale-timer-countdown';

      bar.appendChild(discount);
      bar.appendChild(label);
      bar.appendChild(countdown);
      titleGroup.parentNode.insertBefore(bar, titleGroup);

      function updateCountdown() {
        updateDiscountLabel();
        var now = new Date();
        var nextHour = new Date(now);
        nextHour.setHours(now.getHours() + 1, 0, 0, 0);
        var remaining = Math.max(0, Math.ceil((nextHour.getTime() - now.getTime()) / 1000));
        var hours = Math.floor(remaining / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;
        countdown.textContent =
          String(hours).padStart(2, '0') + 'h ' +
          String(minutes).padStart(2, '0') + 'm ' +
          String(seconds).padStart(2, '0') + 's';
      }

      updateCountdown();
      window.setInterval(updateCountdown, 1000);
    });
  }

  function startGinniSaleTimers() {
    initializeGinniSaleTimers();
    window.setTimeout(initializeGinniSaleTimers, 250);
    window.setTimeout(initializeGinniSaleTimers, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGinniSaleTimers);
  } else {
    startGinniSaleTimers();
  }

  document.addEventListener('shopify:section:load', startGinniSaleTimers);
})();


/* =========================================================
   Section 33 - Delivery location switcher
   ========================================================= */

(function () {

  function updateGinniDelivery(selector) {

    if (!selector) {
      return;
    }


    var card =
      selector.closest('.ginni-delivery-card');


    if (!card) {
      return;
    }


    var content =
      card.querySelector('.ginni-delivery-content');


    if (!content) {
      return;
    }


    var title =
      content.querySelector('.ginni-delivery-title');


    var subtitle =
      content.querySelector('.ginni-service-subtitle');


    if (!title || !subtitle) {
      return;
    }


    if (selector.value === 'karachi') {

      title.textContent =
        content.dataset.karachiTitle ||
        'Express Delivery';


      subtitle.textContent =
        content.dataset.karachiSubtitle ||
        'Guaranteed delivery by tomorrow';

    } else {

      title.textContent =
        content.dataset.otherTitle ||
        'Standard Delivery';


      subtitle.textContent =
        content.dataset.otherSubtitle ||
        'Delivery in 4-6 days depending on location';

    }

  }


  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target &&
        event.target.matches('.ginni-delivery-location')
      ) {

        updateGinniDelivery(event.target);

      }

    }
  );


  function initializeDeliverySelectors() {

    document
      .querySelectorAll('.ginni-delivery-location')
      .forEach(
        function (selector) {

          updateGinniDelivery(selector);

        }
      );

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeDeliverySelectors
    );

  } else {

    initializeDeliverySelectors();

  }

})();

/* =========================================================
   Section 34 - Responsive Description Positioning
   ========================================================= */

(function () {

  function getDetailsColumn() {

    return document.querySelector(
      '.ginni-product-details-column'
    );

  }


  function getDescriptionCard() {

    return document.querySelector(
      '.ginni-description-card'
    );

  }


  function getDescriptionInner(card) {

    if (!card) {
      return null;
    }

    return card.querySelector(
      '.ginni-description-inner'
    );

  }


  function moveNativeDescription() {

    var details =
      getDetailsColumn();

    var card =
      getDescriptionCard();


    if (
      !details ||
      !card
    ) {

      return false;

    }


    var inner =
      getDescriptionInner(card);


    if (!inner) {
      return false;
    }


    /*
     * The native Horizon description is moved
     * into our custom Description card only once.
     */

    if (
      !inner.querySelector(
        'rte-formatter'
      )
    ) {

      var nativeDescription =
        details.querySelector(
          'rte-formatter.rte'
        );


      if (
        nativeDescription &&
        !nativeDescription.closest(
          '.ginni-description-card'
        )
      ) {

        inner.appendChild(
          nativeDescription
        );

      }

    }


    return true;

  }


  function positionDescription() {

    var details =
      getDetailsColumn();

    var card =
      getDescriptionCard();


    if (
      !details ||
      !card
    ) {

      return false;

    }


    moveNativeDescription();


    /*
     * =====================================================
     * MOBILE + TABLET
     * =====================================================
     */

    if (
      window.innerWidth <= 1199
    ) {

      var sidebar =
        document.querySelector(
          '.ginni-delivery-sidebar'
        );


      if (!sidebar) {
        return false;
      }


      var fulfilled =
        sidebar.querySelector(
          '.ginni-fulfilled-card'
        );


      /*
       * Description goes after the
       * Sold & Fulfilled card.
       */

      if (fulfilled) {

        if (
          fulfilled.nextElementSibling !==
          card
        ) {

          fulfilled.insertAdjacentElement(
            'afterend',
            card
          );

        }

      } else {

        if (
          sidebar.lastElementChild !==
          card
        ) {

          sidebar.appendChild(
            card
          );

        }

      }


      return true;

    }


    /*
     * =====================================================
     * DESKTOP
     * =====================================================
     *
     * IMPORTANT:
     *
     * Section 36 moves the counter into
     * Horizon's product-details group.
     *
     * Therefore we wait until Section 36
     * has finished positioning it.
     */

    var counter =
      details.querySelector(
        '.ginni-interest-counter'
      );


    if (!counter) {
      return false;
    }


    /*
     * Section 36 sets this attribute after
     * successfully positioning the counter.
     */

    if (
      counter.dataset.positioned !==
      'true'
    ) {

      return false;

    }


    /*
     * Put Description immediately after
     * the counter in its NEW parent.
     *
     * This is the important difference from
     * the previous version.
     */

    var productDetails =
  counter.closest(
    '.product-details'
  );


if (
  productDetails &&
  productDetails.parentElement
) {

  var parent =
    productDetails.parentElement;


  /*
   * Put Description after the entire
   * Horizon product-details block.
   */

  if (
    productDetails.nextElementSibling !==
    card
  ) {

    productDetails.insertAdjacentElement(
      'afterend',
      card
    );

  }

}


    /*
     * Make sure no old positioning styles
     * interfere.
     */

    card.style.removeProperty(
      'top'
    );

    card.style.removeProperty(
      'bottom'
    );

    card.style.removeProperty(
      'left'
    );

    card.style.removeProperty(
      'right'
    );


    return true;

  }


  /*
   * =====================================================
   * INITIALIZATION
   * =====================================================
   */

  function initializeDescriptionPositioning() {

    positionDescription();


    /*
     * Section 36 runs independently.
     *
     * These checks allow it to finish moving
     * the counter before we move the Description.
     */

    setTimeout(
      positionDescription,
      100
    );

    setTimeout(
      positionDescription,
      300
    );

    setTimeout(
      positionDescription,
      600
    );

    setTimeout(
      positionDescription,
      1000
    );

    setTimeout(
      positionDescription,
      1500
    );

    setTimeout(
      positionDescription,
      2000
    );

    setTimeout(
      positionDescription,
      3000
    );

  }


  /*
   * Initial page load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeDescriptionPositioning
    );

  } else {

    initializeDescriptionPositioning();

  }


  /*
   * Responsive resize
   */

  var resizeTimer = null;


  window.addEventListener(
    'resize',
    function () {

      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(
          positionDescription,
          150
        );

    }
  );


  /*
   * Shopify theme editor
   */

  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        initializeDescriptionPositioning,
        100
      );

    }
  );

})();

/* =========================================================
   Section 35 - Shopper interest counter
   ========================================================= */

(function () {

  var INITIAL_COUNT =
    Math.floor(
      Math.random() *
      (144 - 12 + 1)
    ) + 12;


  var MIN_COUNT = 12;

  var MAX_COUNT = 144;

  var UPDATE_INTERVAL = 4000;


  var POSSIBLE_CHANGES = [

    -1,
    -2,
    -3,
    -4,
    -5,
    -6,
    -7,
    -8,
    -9,
    -10,

    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10

  ];


  function initializeInterestCounter() {

    var counters =
      document.querySelectorAll(
        '.ginni-interest-counter'
      );


    if (!counters.length) {
      return;
    }


    counters.forEach(
      function (counter) {

        if (
          counter.dataset.initialized ===
          'true'
        ) {

          return;

        }


        counter.dataset.initialized =
          'true';


        var numberElement =
          counter.querySelector(
            '.ginni-interest-number'
          );


        if (!numberElement) {
          return;
        }


        var currentNumber =
          INITIAL_COUNT;


        numberElement.textContent =
          currentNumber;


        setInterval(
          function () {

            var randomIndex =
              Math.floor(
                Math.random() *
                POSSIBLE_CHANGES.length
              );


            var change =
              POSSIBLE_CHANGES[randomIndex];


            currentNumber += change;


            if (
              currentNumber <
              MIN_COUNT
            ) {

              currentNumber =
                MIN_COUNT;

            }


            if (
              currentNumber >
              MAX_COUNT
            ) {

              currentNumber =
                MAX_COUNT;

            }


            numberElement.textContent =
              currentNumber;

          },
          UPDATE_INTERVAL
        );

      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeInterestCounter
    );

  } else {

    initializeInterestCounter();

  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      initializeInterestCounter();

      initializeDeliverySelectorsIfAvailable();

    }
  );

})();

/* =========================================================
   Section 36 - Shopper Interest Positioning
   ========================================================= */

(function () {

  function getDetailsColumn() {

    return document.querySelector(
      '.ginni-product-details-column'
    );

  }


  function getCounter(details) {

    if (!details) {
      return null;
    }

    return details.querySelector(
      '.ginni-interest-counter'
    );

  }


  function findProductTitle(details) {

    if (!details) {
      return null;
    }


    /*
     * Try Horizon's common product-title selectors.
     */

    var title =
      details.querySelector(
        '[data-testid="product-title"]'
      );


    if (title) {
      return title;
    }


    title =
      details.querySelector(
        '.product-title'
      );


    if (title) {
      return title;
    }


    /*
     * Fallback:
     * Find the first H1 inside product details.
     */

    title =
      details.querySelector(
        'h1'
      );


    if (title) {
      return title;
    }


    return null;

  }


  function findTitleContainer(title) {

    if (!title) {
      return null;
    }


    /*
     * If Horizon wraps the title in a group block,
     * put the counter before that entire group.
     */

    var group =
      title.closest(
        '.group-block'
      );


    if (
      group &&
      group.closest(
        '.ginni-product-details-column'
      )
    ) {

      return group;

    }


    return title;

  }


  function positionInterestCounter() {

    var details =
      getDetailsColumn();


    if (!details) {
      return false;
    }


    var counter =
      getCounter(details);


    if (!counter) {
      return false;
    }


    var title =
      findProductTitle(details);


    if (!title) {
      return false;
    }


    var titleContainer =
      findTitleContainer(title);


    if (!titleContainer) {
      return false;
    }


    /*
     * Match the reference layout: place the counter
     * immediately below the product rating/stars.
     * If no rating element exists, fall back below the title.
     */
    var rating = details.querySelector(
      '.jdgm-prev-badge, .jdgm-widget .jdgm-prev-badge, ' +
      '.rating, .product-rating, .rating-stars, ' +
      '[class*="rating-stars"], [class*="product-rating"], ' +
      '[aria-label*="star" i], [data-rating]'
    );

    var target = null;
    if (rating && !rating.contains(counter)) {
      target = rating.closest('.group-block') || rating;
    }

    if (target && target.parentNode) {
      if (target.nextElementSibling !== counter) {
        target.insertAdjacentElement('afterend', counter);
      }
    } else if (titleContainer.parentNode) {
      if (titleContainer.nextElementSibling !== counter) {
        titleContainer.insertAdjacentElement('afterend', counter);
      }
    }


    counter.style.setProperty(
      'margin-top',
      '0px',
      'important'
    );


    counter.style.setProperty(
      'margin-bottom',
      '6px',
      'important'
    );


    counter.dataset.positioned =
      'true';


    return true;

  }


  function initializePositioning() {

    positionInterestCounter();


    setTimeout(
      positionInterestCounter,
      100
    );


    setTimeout(
      positionInterestCounter,
      300
    );


    setTimeout(
      positionInterestCounter,
      700
    );


    setTimeout(
      positionInterestCounter,
      1200
    );


    setTimeout(
      positionInterestCounter,
      2000
    );


    setTimeout(
      positionInterestCounter,
      3000
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializePositioning
    );

  } else {

    initializePositioning();

  }


  /*
   * Watch Horizon dynamic rendering.
   */

  // var observer =
  //   new MutationObserver(
  //     function () {

  //       positionInterestCounter();

  //     }
  //   );


  // observer.observe(
  //   document.body,
  //   {
  //     childList: true,
  //     subtree: true
  //   }
  // );


  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        initializePositioning,
        100
      );

    }
  );

})();


/* =========================================================
   Section 37 - Theme editor delivery initialization
   ========================================================= */

function initializeDeliverySelectorsIfAvailable() {

  document
    .querySelectorAll(
      '.ginni-delivery-location'
    )
    .forEach(
      function (selector) {

        var event =
          new Event(
            'change',
            {
              bubbles: true
            }
          );


        selector.dispatchEvent(event);

      }
    );

}

/* =========================================================
   Section 38 - Automatic Discount Badge
   ========================================================= */

(function () {

  var badgeCreated = false;


  function getDiscountData() {

    var data =
      document.querySelector(
        '.ginni-discount-data'
      );


    if (!data) {
      return null;
    }


    var price =
      parseInt(
        data.dataset.price || '0',
        10
      );


    var compareAt =
      parseInt(
        data.dataset.compareAt || '0',
        10
      );


    if (
      !price ||
      !compareAt ||
      compareAt <= price
    ) {

      return null;

    }


    var discount =
      Math.round(
        (
          (compareAt - price) /
          compareAt
        ) * 100
      );


    if (
      discount <= 0 ||
      discount >= 100
    ) {

      return null;

    }


    return discount;

  }


  function findPriceContainer() {

    var details =
      document.querySelector(
        '.ginni-product-details-column'
      );


    if (!details) {
      return null;
    }


    var selectors = [

      '[data-testid="price"]',

      'price-component',

      '.price',

      '.product-price',

      '.price-container'

    ];


    for (
      var i = 0;
      i < selectors.length;
      i++
    ) {

      var element =
        details.querySelector(
          selectors[i]
        );


      if (element) {
        return element;
      }

    }


    return null;

  }


  function addDiscountBadge() {

    /*
     * If badge already exists, do absolutely nothing.
     *
     * This is important because repeatedly changing
     * the badge can trigger Shopify's DOM observers.
     */

    if (
      document.querySelector(
        '.ginni-save-pill'
      )
    ) {

      return;

    }


    var discount =
      getDiscountData();


    if (!discount) {
      return;
    }


    var priceContainer =
      findPriceContainer();


    if (!priceContainer) {
      return;
    }


    var badge =
      document.createElement(
        'span'
      );


    badge.className =
      'ginni-save-pill';


    badge.textContent =
      'SAVE ' + discount + '%';


    /* =========================================================
   Place SAVE pill after the cut-through / compare-at price
   Desired order:
   Price → Cut-through price → SAVE %
   ========================================================= */

    var compareAtElement =
      priceContainer.parentElement.querySelector(
        '.compare-at-price, ' +
        '.price__compare-at, ' +
        '.price__compare, ' +
        '.price-item--regular, ' +
        's'
      );

    if (compareAtElement) {

      compareAtElement.insertAdjacentElement(
        'afterend',
        badge
      );

    } else {

      /* Fallback if Horizon has not rendered the
        compare-at price yet */
      priceContainer.insertAdjacentElement(
        'afterend',
        badge
      );

    }

    


    badgeCreated = true;

  }


  function initializeDiscountBadge() {

    addDiscountBadge();

  }


  /*
   * Initial load
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeDiscountBadge
    );

  } else {

    initializeDiscountBadge();

  }


  /*
   * Horizon can render the price slightly later.
   *
   * We use a few one-time checks instead of a
   * MutationObserver to avoid an infinite DOM loop.
   */

  setTimeout(
    addDiscountBadge,
    100
  );

  setTimeout(
    addDiscountBadge,
    300
  );

  setTimeout(
    addDiscountBadge,
    700
  );

  setTimeout(
    addDiscountBadge,
    1200
  );


  /*
   * Variant changes.
   *
   * Give Horizon time to update the price first.
   */

  document.addEventListener(
    'change',
    function () {

      /*
       * Remove old badge because the selected
       * variant may have a different discount.
       */

      var oldBadge =
        document.querySelector(
          '.ginni-save-pill'
        );


      if (oldBadge) {

        oldBadge.remove();

      }


      badgeCreated = false;


      setTimeout(
        addDiscountBadge,
        150
      );


      setTimeout(
        addDiscountBadge,
        500
      );


      setTimeout(
        addDiscountBadge,
        1000
      );

    }
  );


})();




/* =========================================================
   Section 39 - Ginni Product Image Lightbox
   ========================================================= */

(function () {

  var lightbox = null;
  var lightboxImage = null;
  var lightboxVideo = null;
  var counter = null;
  var images = [];
  var currentIndex = 0;
  var zoomLevel = 1;
  var translateX = 0;
  var translateY = 0;
  var dragStartX = 0;
  var dragStartY = 0;
  var startTranslateX = 0;
  var startTranslateY = 0;
  var dragging = false;

  /* =========================================================
     Section 39A - Floating video data

     ONLY the Shopify-hosted custom.floating_video file is used.
     custom.floating_video_url / YouTube Shorts are NOT used.
     ========================================================= */
  var videoData = document.querySelector('.ginni-lightbox-video-data');
  var floatingVideoUrl = videoData
    ? videoData.getAttribute('data-video-url') || ''
    : '';
  var videoItem = '__GINNI_FLOATING_VIDEO__';

  function getImageSource(img) {
    if (!img) {
      return '';
    }

    return (
      img.currentSrc ||
      img.getAttribute('data-src') ||
      img.getAttribute('data-original') ||
      img.getAttribute('src') ||
      ''
    );
  }

  function collectGalleryImages() {
    var media = document.querySelector('.ginni-product-media');

    if (!media) {
      return [];
    }

    var found = [];
    var seen = {};

    media.querySelectorAll('img').forEach(function (img) {
      var source = getImageSource(img);

      if (!source) {
        return;
      }

      /*
       * Ignore tiny placeholder/data images.
       */
      if (
        source.indexOf('data:image') === 0 ||
        source.indexOf('data:') === 0
      ) {
        return;
      }

      /*
       * Use the URL without its Shopify size suffix where possible,
       * so the thumbnail and main image are treated as one image.
       */
      var key = source
        .replace(/([_-])(pico|icon|thumb|small|compact|medium|large|grande|master|[0-9]+x[0-9]*)(?=\.[a-z0-9]+(?:\?|$))/i, '')
        .split('?')[0];

      if (!seen[key]) {
        seen[key] = true;
        found.push(source);
      }
    });

    /* =======================================================
       Section 39B - Add floating video as final lightbox item

       Only custom.floating_video is included. YouTube Shorts are
       deliberately excluded from this image lightbox.
       ======================================================= */
    if (floatingVideoUrl) {
      found.push(videoItem);
    }

    return found;
  }

  function createLightbox() {
    if (lightbox) {
      return;
    }

    lightbox = document.createElement('div');
    lightbox.className = 'ginni-image-lightbox';
    lightbox.setAttribute('aria-hidden', 'true');

    lightbox.innerHTML =
      '<div class="ginni-image-lightbox__viewport" role="dialog" aria-modal="true" aria-label="Product image viewer">' +
        '<button type="button" class="ginni-image-lightbox__close" aria-label="Close image viewer">&times;</button>' +
        '<button type="button" class="ginni-image-lightbox__prev" aria-label="Previous image">&#10094;</button>' +
        '<img class="ginni-image-lightbox__image" alt="" draggable="false">' +
        '<video class="ginni-image-lightbox__video" playsinline muted loop controls preload="metadata"></video>' +
        '<button type="button" class="ginni-image-lightbox__next" aria-label="Next image">&#10095;</button>' +
        '<button type="button" class="ginni-image-lightbox__zoom" aria-label="Zoom in">+</button>' +
        '<div class="ginni-image-lightbox__counter" aria-live="polite"></div>' +
      '</div>';

    document.body.appendChild(lightbox);

    lightboxImage = lightbox.querySelector('.ginni-image-lightbox__image');
    lightboxVideo = lightbox.querySelector('.ginni-image-lightbox__video');
    counter = lightbox.querySelector('.ginni-image-lightbox__counter');

    lightbox.querySelector('.ginni-image-lightbox__close')
      .addEventListener('click', closeLightbox);

    lightbox.querySelector('.ginni-image-lightbox__prev')
      .addEventListener('click', function (event) {
        event.stopPropagation();
        showImage(currentIndex - 1);
      });

    lightbox.querySelector('.ginni-image-lightbox__next')
      .addEventListener('click', function (event) {
        event.stopPropagation();
        showImage(currentIndex + 1);
      });

    lightbox.querySelector('.ginni-image-lightbox__zoom')
      .addEventListener('click', function (event) {
        event.stopPropagation();

        /* Zoom is only relevant to product images, not the video slide. */
        if (images[currentIndex] === videoItem) {
          return;
        }

        toggleZoom();
      });

    lightbox.addEventListener('click', function (event) {
      if (
        event.target === lightbox ||
        event.target.classList.contains('ginni-image-lightbox__viewport')
      ) {
        closeLightbox();
      }
    });

    var suppressNextImageClick = false;

    lightboxImage.addEventListener('click', function (event) {
      event.stopPropagation();

      /* A pinch gesture can finish with a synthetic click on mobile.
       * Do not let that click toggle the zoom level.
       */
      if (suppressNextImageClick) {
        suppressNextImageClick = false;
        return;
      }

      if (zoomLevel === 1) {
        setZoom(2);
      } else {
        setZoom(1);
      }
    });

    /*
     * Mouse drag while zoomed.
     */
    lightboxImage.addEventListener('mousedown', function (event) {
      if (zoomLevel <= 1) {
        return;
      }

      dragging = true;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      startTranslateX = translateX;
      startTranslateY = translateY;
      lightboxImage.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (event) {
      if (!dragging) {
        return;
      }

      translateX =
        startTranslateX +
        (event.clientX - dragStartX);

      translateY =
        startTranslateY +
        (event.clientY - dragStartY);

      updateImageTransform();
    });

    window.addEventListener('mouseup', function () {
      if (!dragging) {
        return;
      }

      dragging = false;
      lightboxImage.classList.remove('is-dragging');
    });

    /*
     * Touch support for mobile:
     * - two-finger pinch zoom
     * - one-finger drag while zoomed
     * - prevent the browser's native gesture/scroll handling
     */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTranslateX = 0;
    var touchStartTranslateY = 0;
    var pinchStartDistance = 0;
    var pinchStartZoom = 1;
    var pinchActive = false;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var swipeDeltaX = 0;
    var swipeTracking = false;
    var swipeDirection = 0;
    var swipeAnimating = false;

    lightboxImage.addEventListener('touchstart', function (event) {
      if (event.touches.length === 2) {
        event.preventDefault();

        swipeTracking = false;
        pinchActive = true;
        suppressNextImageClick = true;
        pinchStartDistance = getTouchDistance(event);
        pinchStartZoom = zoomLevel;
        lightboxImage.classList.add('is-pinch-zooming');
        return;
      }

      if (event.touches.length === 1) {
        swipeStartX = event.touches[0].clientX;
        swipeStartY = event.touches[0].clientY;
        swipeDeltaX = 0;

        if (zoomLevel > 1) {
          event.preventDefault();

          swipeTracking = false;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchStartTranslateX = translateX;
          touchStartTranslateY = translateY;
        } else {
          swipeTracking = true;
          lightboxImage.classList.remove('is-swiping');
        }
      }
    }, { passive: false });

    lightboxImage.addEventListener('touchmove', function (event) {
      if (event.touches.length === 2) {
        event.preventDefault();

        if (pinchStartDistance > 0) {
          var currentDistance = getTouchDistance(event);
          var pinchScale = currentDistance / pinchStartDistance;

          setZoom(
            Math.max(
              1,
              Math.min(
                3,
                pinchStartZoom * pinchScale
              )
            ),
            true
          );
        }

        return;
      }

      if (
        event.touches.length === 1 &&
        zoomLevel > 1 &&
        !pinchActive
      ) {
        event.preventDefault();

        translateX =
          touchStartTranslateX +
          (event.touches[0].clientX - touchStartX);

        translateY =
          touchStartTranslateY +
          (event.touches[0].clientY - touchStartY);

        updateImageTransform();
        return;
      }

      if (
        event.touches.length === 1 &&
        zoomLevel === 1 &&
        swipeTracking &&
        !pinchActive &&
        !swipeAnimating
      ) {
        var currentX = event.touches[0].clientX;
        var currentY = event.touches[0].clientY;
        var deltaX = currentX - swipeStartX;
        var deltaY = currentY - swipeStartY;

        /* Only treat predominantly horizontal movement as a swipe. */
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
          event.preventDefault();
          swipeDeltaX = deltaX;
          lightboxImage.style.transform =
            'translate3d(' + swipeDeltaX + 'px, 0, 0) scale(1)';
        }
      }
    }, { passive: false });

    lightboxImage.addEventListener('touchend', function (event) {
      if (pinchActive) {
        suppressNextImageClick = true;

        if (event.touches.length < 2) {
          pinchActive = false;
          pinchStartDistance = 0;
          lightboxImage.classList.remove('is-pinch-zooming');
        }

        return;
      }

      if (zoomLevel <= 1 && swipeTracking && !swipeAnimating) {
        var threshold = Math.min(80, Math.max(45, window.innerWidth * 0.12));
        var absDelta = Math.abs(swipeDeltaX);

        if (absDelta >= threshold) {
          swipeDirection = swipeDeltaX < 0 ? -1 : 1;
          swipeAnimating = true;
          swipeTracking = false;
          suppressNextImageClick = true;

          lightboxImage.classList.add('is-swiping');
          /*
           * REVERSED mobile animation:
           * Swipe LEFT -> next image enters from RIGHT.
           * Swipe RIGHT -> previous image enters from LEFT.
           * Match the physical swipe direction exactly:
           *
           * Swipe LEFT  (-1): current image exits LEFT, next enters RIGHT.
           * Swipe RIGHT (+1): current image exits RIGHT, previous enters LEFT.
           */
          lightboxImage.style.transform =
            'translate3d(' +
            (swipeDirection * window.innerWidth) +
            'px, 0, 0) scale(1)';

          window.setTimeout(function () {
            showImage(currentIndex + (swipeDirection === -1 ? 1 : -1));

            /* Put the incoming image on the side it should enter from. */
            lightboxImage.classList.remove('is-swiping');
            lightboxImage.style.transition = 'none';
            lightboxImage.style.transform =
              'translate3d(' +
              (-swipeDirection * window.innerWidth) +
              'px, 0, 0) scale(1)';

            void lightboxImage.offsetWidth;

            lightboxImage.classList.add('is-swiping');
            lightboxImage.style.transform =
              'translate3d(0, 0, 0) scale(1)';

            window.setTimeout(function () {
              lightboxImage.classList.remove('is-swiping');
              lightboxImage.style.transition = '';
              swipeAnimating = false;
              swipeDirection = 0;
            }, 60);
          }, 60);

          return;
        }

        lightboxImage.classList.add('is-swiping');
        lightboxImage.style.transform =
          'translate3d(0, 0, 0) scale(1)';

        window.setTimeout(function () {
          lightboxImage.classList.remove('is-swiping');
        }, 60);
      }

      swipeTracking = false;
      swipeDeltaX = 0;

      if (zoomLevel <= 1 && !swipeAnimating) {
        resetPan();
        updateImageTransform();
      }
    }, { passive: false });

    lightboxImage.addEventListener('touchcancel', function () {
      pinchActive = false;
      pinchStartDistance = 0;
      swipeTracking = false;
      swipeDeltaX = 0;
      swipeAnimating = false;
      lightboxImage.classList.remove('is-pinch-zooming');
      lightboxImage.classList.add('is-swiping');
      lightboxImage.style.transform = 'translate3d(0, 0, 0) scale(1)';
      window.setTimeout(function () {
        lightboxImage.classList.remove('is-swiping');
      }, 60);
      suppressNextImageClick = true;
    }, { passive: false });

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.classList.contains('is-open')) {
        return;
      }

      if (event.key === 'Escape') {
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        showImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        showImage(currentIndex + 1);
      } else if (event.key === '+' || event.key === '=') {
        if (images[currentIndex] !== videoItem) {
          setZoom(Math.min(3, zoomLevel + 0.5));
        }
      } else if (event.key === '-') {
        if (images[currentIndex] !== videoItem) {
          setZoom(Math.max(1, zoomLevel - 0.5));
        }
      }
    });

    /*
     * Prevent browser page scrolling while the lightbox is open.
     */
    lightbox.addEventListener('wheel', function (event) {
      if (!lightbox.classList.contains('is-open')) {
        return;
      }

      event.preventDefault();

      /* Do not zoom the YouTube iframe itself. */
      if (images[currentIndex] === videoItem) {
        return;
      }

      var amount = event.deltaY < 0 ? 0.25 : -0.25;

      setZoom(
        Math.max(
          1,
          Math.min(
            3,
            zoomLevel + amount
          )
        )
      );
    }, { passive: false });
  }

  function getTouchDistance(event) {
    var dx =
      event.touches[0].clientX -
      event.touches[1].clientX;

    var dy =
      event.touches[0].clientY -
      event.touches[1].clientY;

    return Math.sqrt(
      (dx * dx) +
      (dy * dy)
    );
  }

  function updateImageTransform() {
    if (!lightboxImage) {
      return;
    }

    lightboxImage.style.transform =
      'translate3d(' +
      translateX +
      'px, ' +
      translateY +
      'px, 0) scale(' +
      zoomLevel +
      ')';
  }

  function resetPan() {
    translateX = 0;
    translateY = 0;
  }

  function setZoom(level, instant) {
    zoomLevel = Math.max(1, Math.min(3, level));

    if (lightboxImage) {
      if (instant) {
        lightboxImage.classList.add('is-pinch-zooming');
      } else {
        lightboxImage.classList.remove('is-pinch-zooming');
      }
    }

    if (zoomLevel === 1) {
      resetPan();
      if (lightboxImage) {
        lightboxImage.classList.remove('is-zoomed');
      }
    } else if (lightboxImage) {
      lightboxImage.classList.add('is-zoomed');
    }

    var zoomButton =
      lightbox && lightbox.querySelector('.ginni-image-lightbox__zoom');

    if (zoomButton) {
      zoomButton.textContent =
        zoomLevel >= 3 ? '−' : '+';

      zoomButton.setAttribute(
        'aria-label',
        zoomLevel >= 3 ? 'Zoom out' : 'Zoom in'
      );
    }

    updateImageTransform();
  }

  function toggleZoom() {
    if (zoomLevel === 1) {
      setZoom(2);
    } else {
      setZoom(1);
    }
  }

  function showImage(index) {
    if (!images.length || !lightboxImage || !lightboxVideo) {
      return;
    }

    /*
     * Loop continuously in both directions.
     */
    if (index < 0) {
      index = images.length - 1;
    }

    if (index >= images.length) {
      index = 0;
    }

    currentIndex = index;

    setZoom(1);
    lightboxImage.classList.remove('is-pinch-zooming', 'is-swiping', 'is-hidden');
    lightboxImage.style.transition = '';
    lightboxImage.style.transform = 'translate3d(0, 0, 0) scale(1)';

    if (images[currentIndex] === videoItem) {
      /* =====================================================
         Section 39C - Floating video slide
         The video is the Shopify-hosted custom.floating_video file.
         ===================================================== */
      lightboxImage.classList.add('is-hidden');
      lightboxImage.removeAttribute('src');

      lightboxVideo.classList.add('is-active');
      lightboxVideo.src = floatingVideoUrl;
      lightboxVideo.currentTime = 0;
      lightboxVideo.muted = true;

      var playPromise = lightboxVideo.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    } else {
      /*
       * Stop the YouTube player before showing the next image.
       */
      lightboxVideo.classList.remove('is-active');
      lightboxVideo.removeAttribute('src');

      lightboxImage.classList.remove('is-hidden');
      lightboxImage.src = images[currentIndex];
    }

    counter.textContent =
      (currentIndex + 1) +
      ' / ' +
      images.length;
  }

  function openLightbox(index) {
    images = collectGalleryImages();

    if (!images.length) {
      return;
    }

    createLightbox();

    currentIndex = index || 0;

    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    showImage(currentIndex);
  }

  function closeLightbox() {
    if (!lightbox) {
      return;
    }

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    /* =========================================================
       Section 39D - Stop floating video when lightbox closes
       ========================================================= */
    if (lightboxVideo) {
      lightboxVideo.pause();
      lightboxVideo.classList.remove('is-active');
      lightboxVideo.removeAttribute('src');
      lightboxVideo.load();
    }

    if (lightboxImage) {
      lightboxImage.classList.remove('is-hidden');
    }

    setZoom(1);
  }

  function initializeImageTriggers() {
    var media = document.querySelector('.ginni-product-media');

    if (!media) {
      return;
    }

    /*
     * Event delegation means Horizon can replace or re-render
     * gallery images without breaking the lightbox.
     */
    if (media.dataset.ginniLightboxInitialized === 'true') {
      return;
    }

    media.dataset.ginniLightboxInitialized = 'true';

    media.addEventListener('click', function (event) {
      var image = event.target.closest('img');

      if (!image || !media.contains(image)) {
        return;
      }

      var galleryImages = collectGalleryImages();
      var source = getImageSource(image);

      if (!source || !galleryImages.length) {
        return;
      }

      var index = galleryImages.indexOf(source);

      /*
       * If the clicked image is a Shopify-sized version,
       * match it by its base URL.
       */
      if (index === -1) {
        var sourceBase = source.split('?')[0];

        index = galleryImages.findIndex(function (item) {
          return item !== videoItem && item.split('?')[0] === sourceBase;
        });
      }

      if (index === -1) {
        index = 0;
      }

      event.preventDefault();
      event.stopPropagation();

      openLightbox(index);
    });

    media.addEventListener('mouseover', function (event) {
      var image = event.target.closest('img');

      if (image && media.contains(image)) {
        image.classList.add('ginni-lightbox-trigger');
      }
    });
  }

  function initializeGinniImageLightbox() {
    initializeImageTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeGinniImageLightbox
    );
  } else {
    initializeGinniImageLightbox();
  }

  document.addEventListener(
    'shopify:section:load',
    function () {
      setTimeout(
        initializeGinniImageLightbox,
        100
      );
    }
  );

})();


/* =========================================================
   Ginni Free Delivery Price Pill
   Show when product price is Rs 1999 or above.
   ========================================================= */
(function () {
  var THRESHOLD = 199900; // Rs 1999 in Shopify cents

  function initializeFreeDeliveryPill() {
    document.querySelectorAll('.ginni-product-details-column')
      .forEach(function (details) {
        var data = details.querySelector('.ginni-discount-data');

        var priceContainer = details.querySelector(
          '[data-testid="price"], price-component, .price, .product-price, .price-container'
        );

        if (!priceContainer) return;

        var pill = details.querySelector('.ginni-free-delivery-pill');

        if (!pill) {
          pill = document.createElement('span');
          pill.className = 'ginni-free-delivery-pill';
          pill.textContent = 'Free Delivery';
          pill.hidden = true;
          pill.setAttribute('aria-label', 'Free delivery on orders of Rs 1999 or above');

          //priceContainer.insertAdjacentElement('afterend', pill);
          var compareAtPrice = details.querySelector(
            '.compare-at-price, .price__compare-at, s.price-item--regular, [data-testid="compare-at-price"]'
          );

          if (compareAtPrice) {
            compareAtPrice.insertAdjacentElement('afterend', pill);
          } else {
            priceContainer.insertAdjacentElement('afterend', pill);
          }
        }

        function updatePill() {
          var priceInCents = data
            ? parseInt(data.getAttribute('data-price') || '0', 10)
            : 0;

          // Read the displayed price as a fallback if the theme
          // updates the selected variant's price.
          var priceText = priceContainer.textContent || '';
          var matches = priceText.match(/[\d,]+(?:\.\d{1,2})?/g);

          if (matches && matches.length) {
            var displayedPrice = parseFloat(
              matches[0].replace(/,/g, '')
            );

            if (Number.isFinite(displayedPrice) && displayedPrice > 0) {
              // Shopify price data is stored in cents.
              // Use the displayed amount only if it is clearly
              // a normal whole-rupee price.
              priceInCents = Math.round(displayedPrice * 100);
            }
          }

          pill.hidden = priceInCents < THRESHOLD;
        }

        updatePill();

        if (!details.dataset.freeDeliveryListener) {
          details.dataset.freeDeliveryListener = 'true';

          document.addEventListener('change', function () {
            setTimeout(updatePill, 200);
            setTimeout(updatePill, 600);
          });

          // Catch price changes made dynamically by the theme.
          var observer = new MutationObserver(function () {
            updatePill();
          });

          observer.observe(priceContainer, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
      });
  }

  function start() {
    initializeFreeDeliveryPill();
    setTimeout(initializeFreeDeliveryPill, 300);
    setTimeout(initializeFreeDeliveryPill, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();





/* =========================================================
   Review-widget fixes: empty pagination and image alt fallback
   ========================================================= */
(function () {
  function initializeGinniReviewFixes() {
    var productTitle = document.querySelector('[data-testid="product-title"], .product-title, h1');
    var titleText = productTitle ? productTitle.textContent.trim() : 'Product';

    document.querySelectorAll('.jdgm-rev-widg').forEach(function (widget) {
      var reviewItems = widget.querySelectorAll('.jdgm-rev');
      var countNode = widget.querySelector('.jdgm-rev-widg__summary-text, .jdgm-rev-widg__summary-average, [data-number-of-reviews]');
      var countText = countNode ? countNode.textContent : '';
      var explicitCount = countNode && countNode.hasAttribute('data-number-of-reviews')
        ? parseInt(countNode.getAttribute('data-number-of-reviews'), 10)
        : NaN;
      var saysNoReviews = /0\s*(reviews?|ratings?)/i.test(countText);
      var isEmpty = reviewItems.length === 0 && (saysNoReviews || explicitCount === 0);
      widget.classList.toggle('ginni-reviews-empty', isEmpty);
      widget.querySelectorAll('.jdgm-paginate').forEach(function (pagination) {
        pagination.classList.toggle('ginni-reviews-empty', isEmpty);
        if (isEmpty) pagination.setAttribute('aria-hidden', 'true');
        else pagination.removeAttribute('aria-hidden');
      });
    });

    /* Add useful fallback alt text only where an image has no meaningful alt. */
    document.querySelectorAll('.ginni-product-information img, .jdgm-rev__pics img, .jdgm-rev__pic-img').forEach(function (img) {
      if (img.hasAttribute('alt') && img.getAttribute('alt').trim()) return;
      var review = img.closest('.jdgm-rev');
      var reviewerNode = review && review.querySelector('.jdgm-rev__author, .jdgm-rev__buyer-name');
      var reviewer = reviewerNode ? reviewerNode.textContent.trim() : '';
      var isReviewImage = !!img.closest('.jdgm-rev__pics, .jdgm-rev__pic-link');
      if (isReviewImage) {
        img.alt = reviewer
          ? 'Customer review photo of ' + titleText + ' shared by ' + reviewer
          : 'Customer review photo of ' + titleText;
      } else if (img.classList.contains('ginni-benefit-icon')) {
        var benefit = img.closest('.ginni-benefit-item');
        var label = benefit && benefit.querySelector('strong');
        img.alt = label ? label.textContent.trim() + ' icon' : 'Store service benefit icon';
      } else if (img.closest('.ginni-fulfilled-logo')) {
        img.alt = 'Ginni online shopping store logo';
      } else {
        img.alt = titleText + ' product image';
      }
    });
  }

  function startGinniReviewFixes() {
    initializeGinniReviewFixes();
    setTimeout(initializeGinniReviewFixes, 400);
    setTimeout(initializeGinniReviewFixes, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGinniReviewFixes);
  } else {
    startGinniReviewFixes();
  }
  document.addEventListener('shopify:section:load', startGinniReviewFixes);

  var observer;
  if (typeof MutationObserver !== 'undefined' && document.documentElement) {
    observer = new MutationObserver(function () {
      initializeGinniReviewFixes();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
